var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "af27a90b-983a-4ac3-8983-9b030c248d88",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "vbl") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "b28fe722-7cc8-4986-9d48-89f829b6b350",
    cx: 34,
    cy: 46.44,
    r: 4.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b28fe722-7cc8-4986-9d48-89f829b6b350",
    cx: 34,
    cy: 96.44,
    r: 4.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b28fe722-7cc8-4986-9d48-89f829b6b350",
    cx: 64,
    cy: 33.44,
    r: 4.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b28fe722-7cc8-4986-9d48-89f829b6b350",
    cx: 64,
    cy: 83.44,
    r: 4.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b28fe722-7cc8-4986-9d48-89f829b6b350",
    cx: 94,
    cy: 46.44,
    r: 4.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b28fe722-7cc8-4986-9d48-89f829b6b350",
    cx: 94,
    cy: 96.44,
    r: 4.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "b28fe722-7cc8-4986-9d48-89f829b6b350",
    d: "M126.35,16.19,2.48,16.25v3H13.75v95.51H115.08V19.19h11.27ZM112.29,112H16.54V19.24l95.75,0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListHome);
export default __webpack_public_path__ + "static/media/list-home.b2a969eb4efc9b03df0d1a0df79481bb.svg";
export { ForwardRef as ReactComponent };